type ChevronRightIconProps = {
  size?: number
  color?: string
  className?: string
}

export function ChevronRightIcon({
  size = 14,
  color = '#6A6E6E',
  className
}: ChevronRightIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 14 14'
      fill='none'
      className={className}
      aria-hidden='true'
      focusable='false'
    >
      <path
        d='M10.4934 5.743L4.75336 0.283002C4.6528 0.187399 4.53439 0.112541 4.40489 0.0627013C4.27539 0.0128613 4.13735 -0.0109844 3.99864 -0.00747436C3.85992 -0.0039643 3.72326 0.0268328 3.59645 0.0831585C3.46964 0.139484 3.35517 0.220235 3.25956 0.320802C3.06649 0.523905 2.962 0.795389 2.96909 1.07553C2.97618 1.35567 3.09426 1.62152 3.29736 1.8146L8.49416 6.7496C8.52865 6.78219 8.55613 6.82147 8.57491 6.86504C8.59368 6.90861 8.60337 6.95556 8.60337 7.003C8.60337 7.05045 8.59368 7.09739 8.57491 7.14097C8.55613 7.18454 8.52865 7.22382 8.49416 7.2564L3.29736 12.1914C3.09538 12.3832 2.97784 12.6473 2.97062 12.9258C2.9634 13.2042 3.06709 13.4741 3.25886 13.6761C3.45064 13.8781 3.71481 13.9956 3.99324 14.0028C4.27168 14.0101 4.54158 13.9064 4.74356 13.7146L10.5074 8.2406C10.6714 8.0762 10.8012 7.88095 10.8893 7.66611C10.9774 7.45127 11.0221 7.2211 11.0208 6.98888C11.0195 6.75667 10.9723 6.52702 10.8817 6.31318C10.7912 6.09934 10.6592 5.90555 10.4934 5.743Z'
        fill={color}
      />
    </svg>
  )
}
